var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgotPassword_page forgotpassword-component--container"},[_c(_vm.currentChallengeType,{tag:"component",staticClass:"isotope-challenge-type"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }